import echarts from 'echarts'
var chart
const install = function (Vue) {
  Object.defineProperties(Vue.prototype, {
    $chart: {
      get () {
        return {
          asmChart: function (id, title, dataObj) {
            chart = echarts.init(document.getElementById(id))
            chart.clear()
            const optionData = {
              title: {
                text: title,
                left: '100',
                top: '15',
                textStyle: {
                  fontSize: 14,
                  fontWeight: '400',
                  color: '#000'
                }
              },
              tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                  let result = params[0].name + '<br>'
                  params.forEach(function (item) {
                    if (item.value) {
                      if (item.seriesName === '预估进度') {
                        result += item.marker + ' ' + item.seriesName + ' : ' + item.value + '%</br>'
                      } else {
                        result += item.marker + ' ' + item.seriesName + ' : ' + item.value + '</br>'
                      }
                    } else {
                      result += item.marker + ' ' + item.seriesName + ' :  - </br>'
                    }
                  })
                  return result
                },
                axisPointer: {
                  type: 'line'
                }
              },
              grid: {
                left: '3%',
                right: '3%',
                bottom: '3%',
                containLabel: true
              },
              legend: {
                orient: 'horizontal',
                right: '20',
                top: '15',
                // itemWidth: 20,
                // itemHeight: 20,
                // icon: 'roundRect',
                data: ['预估进度', 'Target', 'Actual', 'Forecast']
              },
              xAxis: {
                type: 'category',
                axisTick: {
                  show: false
                },
                axisLine: {
                  show: false
                },
                data: dataObj.monthList
                // data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
              },
              yAxis: [
                {
                  axisTick: {
                    show: false
                  },
                  axisLine: {
                    show: false
                  },
                  type: 'value'
                },
                {
                  axisTick: {
                    show: false
                  },
                  axisLine: {
                    show: false
                  },
                  splitLine: {
                    show: false
                  },
                  type: 'value',
                  // name: '温度',
                  // min: 0,
                  // max: 25,
                  // interval: 5,
                  axisLabel: {
                    color: '#B44138',
                    formatter: '{value} %'
                  }
                }
              ],
              series: [
                {
                  name: 'Actual',
                  yAxisIndex: 0,
                  stack: '总量',
                  barMaxWidth: 20,
                  itemStyle: {
                    color: '#398AC4'
                  },
                  label: {
                    show: true,
                    position: 'top'
                  },
                  // data: [120, 200, 150, 80, 70, 110, null, null, null, null],
                  data: dataObj.actualList,
                  type: 'bar'
                },
                {
                  name: 'Forecast',
                  yAxisIndex: 0,
                  stack: '总量',
                  barMaxWidth: 20,
                  itemStyle: {
                    color: '#EA6D37'
                  },
                  label: {
                    show: true,
                    position: 'top'
                  },
                  // data: [null, null, null, null, null, null, 130, 70, 110, 130],
                  data: dataObj.forecastList,
                  type: 'bar'
                },
                // {
                //   name: '预估进度',
                //   yAxisIndex: 1,
                //   data: dataObj.completionList,
                //   type: 'line'
                // },
                {
                  name: 'Target',
                  yAxisIndex: 0,
                  data: dataObj.targetList,
                  type: 'line'
                }
              ]
            }
            chart.setOption(optionData)
            chart.resize()
            // chart.on('legendselectchanged', function (obj) {
            //   console.log(obj)
            // })
          },
          chartResize: function () {
            chart.resize()
          }
        }
      }
    }
  })
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/assets/js/myCharts.js